import { config } from "common/config";
import { formatTokenAmount } from "features/wallet/utils";
import useTranslate from "ui/locale/hooks/useTranslate";
import { useFormatBalance } from "ui/wallet/components/display/Balance/hook/useFormatBalance";

export interface UsePointsBalanceHintParams {
    lte?: string;
    isLoading?: boolean;
}

export default function usePointsBalanceHint({ lte, isLoading: isLoadingProp }: UsePointsBalanceHintParams) {
    const decimals = config.organization.decimals;

    const translate = useTranslate();
    const formattedMaxBalance = formatTokenAmount(lte || "0", decimals || 0);
    const formattedFiatBalance = useFormatBalance(formattedMaxBalance, {});

    const availableHint = lte ? translate("maxPoints", { points: formattedFiatBalance, units: config.organization.pointUnit }) : undefined;
    const loadingHint = `${translate("loading")}...`;
    const isLoading = isLoadingProp;
    const hint = isLoading ? loadingHint : availableHint;

    return {
        hint,
    };
}
